export default "__VITE_ASSET__CNjMtPd$__"